/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform User Consent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request object for an user giving their consent to an agreement.
 * @export
 * @interface UserAgreementConsentRequest
 */
export interface UserAgreementConsentRequest {
    /**
     * Id of the user that gives consent.
     * @type {string}
     * @memberof UserAgreementConsentRequest
     */
    userId: string;
    /**
     * Id of the user agreement that the user give their consent to.
     * @type {string}
     * @memberof UserAgreementConsentRequest
     */
    agreementId: string;
}

export function UserAgreementConsentRequestFromJSON(json: any): UserAgreementConsentRequest {
    return UserAgreementConsentRequestFromJSONTyped(json, false);
}

export function UserAgreementConsentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAgreementConsentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'agreementId': json['agreementId'],
    };
}

export function UserAgreementConsentRequestToJSON(value?: UserAgreementConsentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'agreementId': value.agreementId,
    };
}


